import { Controller } from "stimulus"

// Saves a trial site ID field on blur / Enter without a Save button.
export default class extends Controller {
  static values = {
    url: String,
    initial: String
  }

  connect() {
    this.savedValue = this.hasInitialValue ? this.initialValue : (this.input()?.value || "")
  }

  save(event) {
    const input = this.input(event)
    if (!input) return

    const value = input.value
    if (value === this.savedValue) return
    if (!this.urlValue) return

    const token = document.querySelector('meta[name="csrf-token"]')?.content
    input.classList.remove("border-green-500", "border-red-500")
    input.disabled = true

    fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-CSRF-Token": token || ""
      },
      credentials: "same-origin",
      body: JSON.stringify({
        prescreen_trial_site: { trial_site_id: value }
      })
    })
      .then((response) => {
        if (!response.ok) {
          return response.json().catch(() => ({})).then((data) => {
            throw new Error((data.errors && data.errors.join(", ")) || "Save failed")
          })
        }
        this.savedValue = value
        input.classList.add("border-green-500")
        window.setTimeout(() => input.classList.remove("border-green-500"), 1000)
      })
      .catch(() => {
        input.classList.add("border-red-500")
      })
      .finally(() => {
        input.disabled = false
      })
  }

  keydown(event) {
    if (event.key === "Enter") {
      event.preventDefault()
      event.target.blur()
    }
  }

  input(event) {
    if (event?.target?.matches?.("input")) return event.target
    return this.element.querySelector("input")
  }
}
